import { QueryStatus } from '@tanstack/react-query';

const prioritizedStatuses: QueryStatus[] = ['error', 'pending', 'success'];

export const queryStatus = (...statuses: QueryStatus[]) =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  prioritizedStatuses.find((s) => statuses.includes(s))!;
